export default "__VITE_ASSET__DihCa8nH__"